import _ from 'lodash'

export const getNewReportState = state => _.get(state, 'newReport')
export const getIsValidSession = ({ reportId }) => state => !!_.get(getNewReportState(state), reportId)
export const getInitialValues = ({ reportId }) => state => _.get(getNewReportState(state), `[${reportId}]initialValues`, {})
export const getUserDetails = ({ reportId }) => state => _.get(getNewReportState(state), `[${reportId}]userDetails`, {})
export const getFormConfig = ({ reportId }) => state => _.get(getNewReportState(state), `[${reportId}]formConfig`, {})
